<template>
  <UIPreloader :message class="main-loader" />
</template>

<script setup lang="ts">
import { UIPreloader } from '@ui/core'

type Props = {
  message?: string
}

defineProps<Props>()
</script>

<style>
.main-loader {
  @apply fixed inset-0;
  @apply bg-white/75 dark:bg-gray-900/75;
  @apply z-30;
}
</style>
